import { createFileRoute } from '@tanstack/react-router'
import FunisPage from '@/pages/dashboard/funis-page'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/funis',
)({
  component: function FunisRoute() {
    const { dashboardId } = Route.useParams()
    
    return (
      <RequireModule module={MODULES.OPORTUNIDADES} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
          <FunisPage />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
